import React, { createContext, useState, useContext } from "react";

const LogoutContext = createContext();

export const LogoutProvider = ({ children }) => {
  const [logoutMessage, setLogoutMessage] = useState("");

  const showLogoutMessage = (message) => {
    setLogoutMessage(message);
    setTimeout(() => setLogoutMessage(""), 3000); 
  };

  return (
    <LogoutContext.Provider value={{ logoutMessage, showLogoutMessage }}>
      {children}
    </LogoutContext.Provider>
  );
};

export const useLogoutContext = () => useContext(LogoutContext);
